import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
    path: 'order-management',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
        /*  Webpack - use 'require.ensure' to create a split point
         and embed an async module loader (jsonp) when bundling   */
        require.ensure([], (require) => {
            /*  Webpack - use require callback to define
             dependencies for bundling   */
            // const HomeView = require('./components/HomeView').default;
            const OrderManagement = require('./containers/orderManagementContainer').default
            const { orderManagementFilterReducer, orderOptionsReducer, loadOrderDetailsReducer } = require('./modules/orderManagement')

            /*  Add the reducer to the store on key 'counter'  */
            injectReducer(store, { key: 'orderManagementFilter', reducer: orderManagementFilterReducer })
            injectReducer(store, { key: 'orderOptions', reducer: orderOptionsReducer })
            injectReducer(store, { key: 'orderDetails', reducer: loadOrderDetailsReducer })
            /*  Return getComponent   */
            cb(null, OrderManagement)

            /* Webpack named bundle   */
        }, 'HomeView')
    }
})



// WEBPACK FOOTER //
// ./src/routes/OrderManagement/index.js